import { useMutation, useQuery } from '@tanstack/react-query'
import type { UseMutationResult } from '@tanstack/react-query'
import { getOrders } from '@/services/outbound/outboundWaitingStatus/apis'
import { requestOperatorReplan } from '@/services/outbound/outboundUnallocated/apis'
import { OperatorReplanBulkResult, OperatorReplanReq } from '@/services/outbound/outboundUnallocated/replan'
import { GetOrdersReq } from '@/services/outbound/outboundWaitingStatus/types'
import { ORDER_STATUS } from '@/services/outbound/outboundWaitingStatus/consts'
import { Utils } from '@/utils/Utils'

const PATHS = ['OUTBOUND', 'UNALLOCATED', 'BATCH', 'gi26']
const GET_UNALLOCATED_ORDERS = [...PATHS, 'GET_UNALLOCATED_ORDERS']

export const useGetUnallocatedOrders = (params: ApiPaginationReq<GetOrdersReq>) => {
  // TODO: [SCOPE B] 아래 다건 입력 구조 데이터 타입을 배열 -> 스트링으로 변환 필요 (API 수정 후 아래 코드 삭제 필요)
  const searchParams = {
    ...params,
    orderNumbers: typeof params.orderNumbers === 'string' ? [params.orderNumbers] : params.orderNumbers,
    orderOptionNumbers: typeof params.orderOptionNumbers === 'string' ? [params.orderOptionNumbers] : params.orderOptionNumbers,
    barcodes: typeof params.barcodes === 'string' ? [params.barcodes] : params.barcodes,
  }

  return useQuery({
    queryKey: [...GET_UNALLOCATED_ORDERS, { ...searchParams, orderStatus: [ORDER_STATUS.INV_UNALLOCATED] }],
    queryFn: () => getOrders({ ...searchParams, orderStatus: [ORDER_STATUS.INV_UNALLOCATED] }, 'GI26'),
    select: ({ data }) => {
      return { ...data, items: Utils.reformatArrayToAddIds(data.items) }
    },
    enabled: false,
  })
}

/**
 * 화주 1곳의 벌크 출고지시. 호출 측이 선택 행을 화주별로 묶어 요청한다 —
 * 성공 후 갱신은 `useGetUnallocatedOrders` 가 `enabled: false` 라 invalidate 가 아니라 refetch 다.
 */
export const useOperatorReplan = (): UseMutationResult<ApiResponseV2<OperatorReplanBulkResult>, Error, OperatorReplanReq> => {
  return useMutation({
    mutationFn: (params: OperatorReplanReq) => requestOperatorReplan(params),
  })
}
